import { render, staticRenderFns } from "./ContractMobileView.vue?vue&type=template&id=50583f0a&"
import script from "./ContractMobileView.vue?vue&type=script&lang=js&"
export * from "./ContractMobileView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports